import getRegionalOptions from '../data/store/store';
import setHasUserChangedLanguage from '../data/mutators/setHasUserChangedLanguage';
import { isFeatureEnabled } from 'owa-feature-flags';

const localeHotReload = (languageHasChanged: boolean) => {
    let optionState = getRegionalOptions();

    if (
        languageHasChanged &&
        (!isFeatureEnabled('fwk-localeHotReload') || optionState.shouldRenameDefaultFolders)
    ) {
        setHasUserChangedLanguage(true);
    }
};

export default localeHotReload;
